/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-24 22:55:09
 * @LastEditTime: 2022-02-09 20:41:16
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-h5/src/common/config.js
 */
export const API_NAME = '/rent-saas'
export const APP_DOWNLOAD_URL = 'https://jnzgj.shouyuhome.com/protocol/#/download/downloadApp'